<template>
  <div>
    <!--
        <v-dialog v-model="compEstadoP" persistent scrollable max-width="80%">
        -->
    <v-card>
      <v-card-title class="modal_title py-5 mb-2">
        <v-row class="d-flex justify-space-between py-0 pl-4">
          {{ title }} SESIÓN DE APRENDIZAJE
          <div>
            <v-btn
              v-if="
                this.compParametroP.evento == 'edit' ||
                this.compParametroP.evento == 'view'
              "
              class="mx-2 btn_ver"
              :loading="descargandoDocumento"
              fab
              x-small
              @click="GenerarDocumento"
            >
              <v-icon>fa-file-download</v-icon>
            </v-btn>
            <v-btn
              v-if="this.compParametroP.evento == 'view'"
              fab
              dark
              x-small
              class="btn_style3"
              @click="CloseModal()"
              ><v-icon dark>fa-times</v-icon></v-btn
            >
          </div>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="text-center py-6">
            <span class="font-weight-bold">Nivel: </span>
            <span class="font-weight-black pr-3">{{
              datosTema.desc_nivel
            }}</span>
            <span class="font-weight-bold">Grado: </span>
            <span class="font-weight-black pr-3">{{
              datosTema.desc_grado
            }}</span>
            <span class="font-weight-bold">Area: </span>
            <span class="font-weight-black pr-3">{{
              datosTema.desc_area
            }}</span>
            <span class="font-weight-bold">Curso: </span>
            <span class="font-weight-black pr-3">{{
              datosTema.desc_curso
            }}</span>
            <br />
            <span class="font-weight-bold">Unidad: </span>
            <span class="font-weight-black pr-3">{{
              datosTema.nombre_tema
            }}</span>
            <span class="font-weight-bold">Tema: </span>
            <span class="font-weight-black pr-3">{{
              datosTema.nombre_clase
            }}</span>
          </v-col>
        </v-row>
        <v-stepper v-model="stepper">
          <v-stepper-header>
            <v-stepper-step editable step="1">
              Datos generales y aprendizaje
            </v-stepper-step>

            <v-stepper-step editable step="2">
              Secuencia didáctica <br />
              Referencia bibliográficas
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-content step="1">
            <SesionAprendizajeComp
              @close="CloseModal"
              :estadoComp="estadoComponente"
              :parametros="parametroComp"
              @reloadComp="ReloadComp"
            >
            </SesionAprendizajeComp>
          </v-stepper-content>
          <v-stepper-content step="2">
            <SecuenciaDidacticaComp
              @close="CloseModal"
              @nextTab="NextTab"
              :estadoComp="estadoSecuenciaComponente"
              :parametros="parametroSecuenciaComp"
            >
            </SecuenciaDidacticaComp>
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import SesionAprendizajeComp from "./componentes/formSesionAprendizaje.vue";
import SecuenciaDidacticaComp from "./componentes/secuenciaDidactica.vue";
export default {
  name: "SesionAprendizaje",
  components: {
    SecuenciaDidacticaComp,
    SesionAprendizajeComp,
  },

  props: {
    compParametroP: {
      type: Object,
    },
    compEstadoP: {
      type: Boolean,
    },
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 141, id_modulo: 5 }, //sud_modulo y modulo
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    test: false,
    stepper: 1,
    tabIndex: 1,
    title: null,
    datosSA: {},
    datosTema: {},
    totalTemas: -1,

    datosSecuencia: {},
    estadoComponente: false,
    parametroComp: {},

    estadoSecuenciaComponente: false,
    parametroSecuenciaComp: {},

    //////////////////////////////////

    descargandoDocumento: false,
    //validaciones de formulario
  }),

  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    compEstadoP() {
      if (this.compEstadoP) {
        this.LoadMain();
      } else {
        //this.parametros = {}
        this.LimpiarForm();
      }
    },

    stepper() {
      if (this.stepper == 1) {
        // this.estadoComponente = true;
        this.estadoSecuenciaComponente = false;
      }
      if (this.stepper == 2) {
        // this.estadoComponente = false;
        this.estadoSecuenciaComponente = true;
      }
    },
  },
  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  created() {
    this.actualizarParamentro();
  },

  async mounted() {
    this.LoadMain();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    LoadMain() {   

      this.stepper = 1;
      this.datosTema = this.compParametroP.item;
      this.parametroComp = {
        evento: this.compParametroP.evento,
        id_clase: this.compParametroP.item.id_clase,
        totalTemas: 0,
        item: this.compParametroP.item,
        bigItem: this.compParametroP.item, //TRICK
      };

      this.parametroSecuenciaComp = {
        evento: this.compParametroP.evento,
        id: -1,
        id_clase: this.compParametroP.item.id_clase,
        item: this.compParametroP.item,
        bigItem: this.compParametroP.item,
      };

      this.estadoComponente = true;

      if (this.compParametroP.evento == "view") {
        this.title = "VISTA";
      }
      if (this.compParametroP.evento == "add") {
        this.title = "AGREGAR";
      }
      if (this.compParametroP.evento == "edit") {
        this.title = "EDITAR";
      }
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    ReloadComp(id_sa, evento, stepper) {
      // this.compParametroP.evento = evento   da error
      this.parametroComp.evento = evento;
      this.parametroSecuenciaComp.evento = evento;
      this.parametroSecuenciaComp.id = id_sa;
      this.datosSA.id = id_sa;
      this.stepper = stepper;
    },

    CloseModal() {
      this.estadoSecuenciaComponente = false;
      this.estadoComponente = false;
      this.$emit("close");
      this.stepper = 1;
    },

    async GenerarDocumento() {

      try {
        this.descargandoDocumento = true;
        const params = {
          id_colegio: this.datoLogin.id_colegio,
        };
        this.datosSA.id_usuario = this.datoLogin.id;
        let url = `/academico/sesionAprendizajeProg/${this.compParametroP.item.id_sesion_aprendizaje}/documento/`;
        let res = await axios.post(url, params, { responseType: "blob" });
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `sesion_aprendizaje_${this.compParametroP.item.id_sesion_aprendizaje}.pdf`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
        // this.setEnviarMens({ tipo: res.data.messageT, mensaje: res.data.message, tiempo: 6000})
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error al generar el documento`,
          tiempo: null,
        });
      }
      this.descargandoDocumento = false;
    },

    NextTab() {
      this.$emit("wizardNext", this.tabIndex);
      // this.$emit('reloadComp')
      // this.$emit('eventComp', this.compParametroP.item)
    },

    LimpiarForm() {},
  },
};
</script>
